
export default function FAQSection() {
  const faqs = [
    {
      question: "Q. 支払い方法は？",
      answer: "A. クレジットカード決済です。"
    },
    {
      question: "Q. いつでも退会できますか？",
      answer: "A. はい、Stripeの会員ページからいつでも退会可能です。"
    },
    {
      question: "Q. 会員期間に制限はありますか？",
      answer: "A. ありません。ご希望の期間だけご参加いただけます。"
    }
  ];

  return (
    <section className="py-16 px-4">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-gray-800">
          よくある質問
        </h2>
        
        <div className="space-y-6">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl border border-teal-200 hover:shadow-lg transition-shadow duration-300 p-6"
            >
              <dt className="font-semibold text-lg text-teal-700 mb-2">
                {faq.question}
              </dt>
              <dd className="text-gray-700 pl-4">
                {faq.answer}
              </dd>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
